export default "__VITE_ASSET__BWhFkcHD__"